export const roles = {
  admin: "Admin",
  superAdmin: "SuperAdmin",
  student: "Student",
  tutor: "Tutor",
};
